import {
    Grid,
    Typography,
    WithStyles,
    withStyles,
  } from "@material-ui/core";
  import React, { Component } from "react";
  import { connect } from "react-redux";
  import { userStyles } from "../styles";
  
  interface TabPanelProps extends WithStyles<typeof userStyles> {
    children: any,
    index: any,
    value: any,
    unmountOnExit?: boolean
  }
  
  class TabPanel extends Component<TabPanelProps> {
    constructor(props:TabPanelProps){
		super(props);
	}  
    render() {
        const { children, value, index, unmountOnExit = true, ...other } = this.props;

      return (
        <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {(value === index || !unmountOnExit) && (
          <Grid style={!unmountOnExit && value !== index ? {display: 'none'} : {} }>
            <Typography>{children}</Typography>
          </Grid>
        )}
      </div>
      );
    }
  }
  
  // @ts-ignore
  export default connect()(withStyles(userStyles)(TabPanel));
  